import { useAccount, useAuth } from '@retainerclub/hooks';
import DashboardLayoutTitleWithPartner from '../../layouts/DashboardLayout/DashboardLayoutTitleWithPartner';
import CommunicationPreferencesForm from './CommunicationPreferencesForm/CommunicationPreferencesForm';

function CommunicationPreferences() {
  const { users } = useAccount();
  const { currentUser } = useAuth();

  const user = users?.find((user) => user?.id === currentUser?.internalId);

  return (
    <>
      <DashboardLayoutTitleWithPartner
        heading="Communication Preferences"
        title="How can we contact you?"
        subtitle="Manage your communication preferences."
      />
      {user && <CommunicationPreferencesForm user={user} />}
    </>
  );
}

export default CommunicationPreferences;
